/* global themeObj */

import $ from "jquery";
import DataTable from "datatables.net-dt";
import { initJawViewer } from "../three/viewer";
import { miShowSnackbar } from "../utils/utils-snackbar";
const dashboard = () => {
  const el = {
    main: ".mi-dashboard",
    baseUrl: "#base_url",
    setupCheckTable: "#MIDashboardSetupCheckTable",
    tabs: ".mi-dashboard__tab__container__inner",
    setupCheckContainer: "#MI-Dashboard-Setup-Check-Table",
    formulaeContainer: "#MI-Dashboard-Formulare",
    learningLingualContainer: "#MI-Dashboard-Learning-Lingual",
    courseContainer: "#MI-Dashboard-Course",
    cta: ".mi-cta",
  };

  const init = () => {
    if ($(el.main).length === 0) return;

    if (screen.width <= 600) {
      $('body').addClass('is-mobile');
    }

    handlerTabs();
    handlerAccordion();
    initTable();
    handlerSnackbar();
    handlerLabelInlineEdit();
  };

  // eslint-disable-next-line
  function format(d, dataset = {}) {
    // `d` is the original data object for the row
    const base_url = $(el.baseUrl).val() || "";
    const translations = window.themeObj?.translationText || {};

    // Show Hide Icon
    const topJaw = `${base_url}/wp-content/themes/starter-theme-custom-doctor/assets/images/ic-jaw-top.svg`;
    const bottomJaw = `${base_url}/wp-content/themes/starter-theme-custom-doctor/assets/images/ic-jaw-bottom.svg`;
    const fullJaw = `${base_url}/wp-content/themes/starter-theme-custom-doctor/assets/images/ic-jaw-full.svg`;

    // Camera Icon
    const topCameraJaw = `${base_url}/wp-content/themes/starter-theme-custom-doctor/assets/images/ic-jaw-camera-top.svg`;
    const frontCameraJaw = `${base_url}/wp-content/themes/starter-theme-custom-doctor/assets/images/ic-jaw-camera-front.svg`;
    const leftCameraJaw = `${base_url}/wp-content/themes/starter-theme-custom-doctor/assets/images/ic-jaw-camera-right.svg`;
    const rightCameraJaw = `${base_url}/wp-content/themes/starter-theme-custom-doctor/assets/images/ic-jaw-camera-left.svg`;

    const currentUrl = new URL(window.location.href);
    currentUrl.search = "";

    return `
			<div class="patient-details">
				<div class="patient-details-top">
					<button class="btn-action btn-action-toggle" data-jaw="upper" data-model="${dataset.upper || ""}">
            <div class="model-jaw">
              <img src="${topJaw}"/>
						  ${translations.upperJaw || "Oberkiefer"}
            </div>
            ${dataset.upper ? `
              <a href="${dataset.upper}" class="model-jaw-download" download="${dataset.name || 'model'}-upper.obj" onclick="event.stopPropagation()">
                <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg" id="Ebene_2" version="1.1" viewBox="0 0 18.9996 14.6569">
                  <defs>
                    <style>.st0 { fill: #bebebe; }</style>
                  </defs>
                  <path class="st0" d="M16.9996,8.2274v3.8709c0,.3076-.251.5586-.5591.5586H2.5591c-.3081,0-.5591-.251-.5591-.5586v-3.8709H0v3.8709c0,1.4111,1.1479,2.5586,2.5591,2.5586h13.8814c1.4111,0,2.5591-1.1475,2.5591-2.5586v-3.8709h-2Z"/>
                  <polygon class="st0" points="14.3519 3.2437 11.0203 3.2437 11.0203 0 7.9794 0 7.9794 3.2437 4.6477 3.2437 9.4998 9.6943 14.3519 3.2437"/>
                </svg>
              </a>
            ` : ''}
					</button>
					<button class="btn-action btn-action-toggle" data-jaw="lower" data-model="${dataset.lower || ""}">
					  <div class="model-jaw">	
              <img src="${bottomJaw}"/>
						  ${translations.lowerJaw || "Unterkiefer"}
            </div>
            ${dataset.lower ? `
              <a href="${dataset.lower}" class="model-jaw-download" download="${dataset.name || 'model'}-lower.obj" onclick="event.stopPropagation()">
                <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg" id="Ebene_2" version="1.1" viewBox="0 0 18.9996 14.6569">
                  <defs>
                    <style>.st0 { fill: #bebebe; }</style>
                  </defs>
                  <path class="st0" d="M16.9996,8.2274v3.8709c0,.3076-.251.5586-.5591.5586H2.5591c-.3081,0-.5591-.251-.5591-.5586v-3.8709H0v3.8709c0,1.4111,1.1479,2.5586,2.5591,2.5586h13.8814c1.4111,0,2.5591-1.1475,2.5591-2.5586v-3.8709h-2Z"/>
                  <polygon class="st0" points="14.3519 3.2437 11.0203 3.2437 11.0203 0 7.9794 0 7.9794 3.2437 4.6477 3.2437 9.4998 9.6943 14.3519 3.2437"/>
                </svg>
              </a>
            ` : ''}
					</button>
					<button class="btn-action btn-action-toggle active" data-jaw="occlusion" data-model="${dataset.occlusion || ""}">
            <div class="model-jaw">	
              <img src="${fullJaw}"/>
						  ${translations.occlusion || "Okklusion"}
            </div>
            ${dataset.occlusion ? `
              <a href="${dataset.occlusion}" class="model-jaw-download" download="${dataset.name || 'model'}-occlusion.obj" onclick="event.stopPropagation()">
                <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg" id="Ebene_2" version="1.1" viewBox="0 0 18.9996 14.6569">
                  <defs>
                    <style>.st0 { fill: #bebebe; }</style>
                  </defs>
                  <path class="st0" d="M16.9996,8.2274v3.8709c0,.3076-.251.5586-.5591.5586H2.5591c-.3081,0-.5591-.251-.5591-.5586v-3.8709H0v3.8709c0,1.4111,1.1479,2.5586,2.5591,2.5586h13.8814c1.4111,0,2.5591-1.1475,2.5591-2.5586v-3.8709h-2Z"/>
                  <polygon class="st0" points="14.3519 3.2437 11.0203 3.2437 11.0203 0 7.9794 0 7.9794 3.2437 4.6477 3.2437 9.4998 9.6943 14.3519 3.2437"/>
                </svg>
              </a>
            ` : ''}
					</button>
				</div>

				<div class="patient-details-canvas" style="position: relative;">
					<div class="patient-details-loader" style="position: absolute; top:0; left:0; right:0; bottom:0; background: #f5f5f5; display: flex; align-items: center; justify-content: center; z-index: 10;">
						<div class="spinner" style="width: 40px; height: 40px; border: 4px solid #ddd; border-top-color: #333; border-radius: 50%; animation: spin 1s linear infinite;"></div>
					</div>
					<canvas width="100%" height="585px"></canvas>
					<style>
						@keyframes spin {
							to { transform: rotate(360deg); }
						}
					</style>
				</div>

				<div class="patient-details-bottom">
					<div class="patient-details-bottom-camera">
						<button class="btn-action btn-action-camera" data-angle="top">
							<img src="${topCameraJaw}"/>
							${translations.topView || "Aufsicht"}
						</button>
						<button class="btn-action btn-action-camera" data-angle="left">
							<img src="${leftCameraJaw}"/>
							${translations.leftView || "Links"}
						</button>
						<button class="btn-action btn-action-camera" data-angle="front">
							<img src="${frontCameraJaw}"/>
							${translations.frontView || "Frontal"}
						</button>
						<button class="btn-action btn-action-camera" data-angle="right">
							<img src="${rightCameraJaw}"/>
							${translations.rightView || "Rechts"}
						</button>
					</div>
          <!-- New bottom content -->
          <div class="patient-details-bottom-new">
            <p class="text-send-email">
              ${translations.feedbackLabel || "Senden Sie Ihr Feedback per E-Mail"}
            </p>
            <a class="btn"
              href="mailto:win@lingualsystems.de?subject=${encodeURIComponent(`${translations.emailSubject || "Setup von Patient"}: ${dataset.name || ""}`)}">
              ${translations.sendEmailBtn || "E-Mail senden"}
            </a>
          </div>
				</div>
			</div>
		`;
  }

  const initTable = () => {
    $.fn.dataTable.ext.errMode = "none";
    const setupCheckTable = new DataTable(el.setupCheckTable, {
      searching: false,
      lengthChange: false,
      paging: false,
      info: false,
      order: [],
      columnDefs: [
        { targets: "no-sort", orderable: false }, // disable sort action column
        { targets: [0, 1, 2], orderSequence: ["asc", "desc"] },
      ],
    });

    $(document).on("click", "#MIDashboardSetupCheckTable tbody tr.patient-row", function (e) {
      // ignore clicks inside form elements
      if (e.target.closest(".patient-details")) {
        return;
      }

      let tr = e.target.closest("tr");
      let row = setupCheckTable.row(tr);
      let dataset = $(tr).data() || {};

      if (row.child.isShown()) {
        row.child.hide();
      } else {
        row.child(format(row.data(), dataset), "expanded-row").show();

        // Hide top camera button on first load since model Okklusion is active 
        $(row.child()).find('.btn-action-camera[data-angle="top"]').css({ opacity: 0, zIndex: -1 });

        const canvas = $(row.child()).find(".patient-details-canvas canvas")[0];
        const loaderEl = $(row.child()).find(".patient-details-loader")[0];

        if (canvas) {
          const filesToLoad = [
            dataset.upper || "",
            dataset.lower || "",
            dataset.occlusion || "",
          ].filter((file) => file !== "");

          const mtlFiles = [
            dataset.upperMtl || "",
            dataset.lowerMtl || "",
            dataset.occlusionMtl || "",
          ];

          if (filesToLoad.length > 0) {
            initJawViewer(canvas, $(el.baseUrl).val() || "", filesToLoad, loaderEl, mtlFiles);
          } else {
            $(row.child())
              .find(".patient-details-canvas")
              .html(
                '<p style="padding: 2rem; text-align: center;">Keine 3D-Modelle verfügbar.</p>',
              );
          }
        }
      }
    });

    const urlParams = new URLSearchParams(window.location.search);
    const patientId = urlParams.get("patient_id");

    if (patientId) {
      const target = $(`#MIDashboardSetupCheckTable tbody tr.patient-row[data-id="${patientId}"]`);

      if (target.length) {
        target[0].scrollIntoView({ behavior: "smooth", block: "center" });
        target.trigger("click");
      }
    }


    $(document).on("click", ".patient-details-top .btn-action-toggle", function (e) {
      e.preventDefault();

      const targetModel = $(this).attr("data-model");
      if (!targetModel) return;

      const patientDetails = $(this).closest(".patient-details");

      $(this).addClass("active").siblings(".btn-action-toggle").removeClass("active");

      if (window.jawViewerData && window.jawViewerData.models) {
        window.jawViewerData.models.forEach((model) => {
          if (model.userData.fileName === targetModel) {
            model.visible = true;
          } else {
            model.visible = false;
          }
        });
      }

      // if button model Okklusion click, hide camera top or data angle top
      if ($(this).data("jaw") === "occlusion") {
        $(this).closest('.patient-details').find('.btn-action-camera[data-angle="top"]').css({ opacity: 0, zIndex: -1 });
      } else {
        $(this).closest('.patient-details').find('.btn-action-camera[data-angle="top"]').css({ opacity: 1, zIndex: 1 })
      }

      patientDetails
        .find('.patient-details-bottom-camera .btn-action-camera[data-angle="front"]')
        .trigger("click");
    });

    $(document).on("click", ".patient-details-bottom-camera .btn-action-camera", function (e) {
      e.preventDefault();
      const angle = $(this).attr("data-angle");
      if (!angle || !window.jawViewerData || !window.jawViewerData.camera) return;

      $(this).siblings(".btn-action-camera").removeClass("active");
      $(this).addClass("active");
      if (!angle || !window.jawViewerData || !window.jawViewerData.camera) return;

      const { camera, controls } = window.jawViewerData;
      const dist = 60;

      const currentJaw = $(".patient-details-top .btn-action-toggle.active").data("jaw");

      switch (angle) {
        case "top":
          camera.up.set(0, 1, 0);

          if (currentJaw === "upper") {
            camera.position.set(0, -dist, 0.001);

            if (window.jawViewerData?.upperJawLight) {
              window.jawViewerData.upperJawLight.intensity = currentJaw === "upper" ? 1.7 : 0;
            }

          } else {
            camera.position.set(0, dist, 0.001);
          }

          break;
        case "left":
          camera.up.set(0, 1, 0);
          camera.position.set(dist, 0, 0);
          break;
        case "front":
          camera.up.set(0, 1, 0);
          camera.position.set(0, 0, dist);
          if (window.jawViewerData?.upperJawLight) {
            const jaw = $(".patient-details-top .btn-action-toggle.active").data("jaw");
            window.jawViewerData.upperJawLight.intensity = jaw === "upper" ? 1.7 : 0;
          }
          break;
        case "right":
          camera.up.set(0, 1, 0);
          camera.position.set(-dist, 0, 0);
          break;
      }

      controls.target.set(0, 0, 0);
      camera.lookAt(0, 0, 0);
      controls.update();
    });




  };

  const handlerTabs = () => {
    const storageKey = "mi_dashboard_active_tab";

    const updateTabContent = (tabName) => {
      const map = {
        "setup-check": el.setupCheckContainer,
        "formulare": el.formulaeContainer,
        "learning-lingual": el.learningLingualContainer,
        "course": el.courseContainer,
      };

      // hide all
      Object.values(map).forEach((selector) => $(selector).hide());

      // show active
      if (map[tabName]) {
        $(map[tabName]).show();
      }

      // for CTA 
      if (tabName === "course") {
        $(el.cta).addClass("show");
      } else {
        $(el.cta).removeClass("show");
      }
    };

    $(document).on("click", el.tabs, function (e) {
      e.preventDefault();

      const tabName = $(this).data("tab");

      $(el.tabs).removeClass("active");
      $(`${el.tabs}[data-tab="${tabName}"]`).addClass("active");

      $(".mi-dashboard__tab")
        .removeClass((i, className) => (className.match(/tab--\S+/g) || []).join(' '))
        .addClass(`tab--${tabName}`);

      if (tabName) {
        const url = new URL(window.location);
        url.searchParams.set("tabs", tabName);
        window.history.replaceState({}, "", url);

        // window.history.pushState({}, "", url);
        localStorage.setItem(storageKey, tabName);

        updateTabContent(tabName);


      }

      // mobile only close sidebar
      if ($(this).hasClass("js-mi-dashboard__tab__mobile__list")) {
        $('.js-mobile-sidebar').fadeToggle();
      }
    });

    const urlParams = new URLSearchParams(window.location.search);
    let activeTab = urlParams.get("tabs");

    if (!activeTab || !["course", "setup-check", "formulare", "learning-lingual"].includes(activeTab)) {
      // activeTab = "setup-check";
      activeTab = localStorage.getItem(storageKey);
    }

    if (!activeTab) {
      activeTab = "course";
    }

    $(el.tabs).removeClass("active");
    $(`${el.tabs}[data-tab="${activeTab}"]`).addClass("active");
    updateTabContent(activeTab);
  };

  const handlerAccordion = () => {
    $(document).on("click", ".mi-accordion__item__header", function () {
      const $content = $(this).next(".mi-accordion__item__content");
      const $icon = $(this).find("svg");
      const isActive = $(this).hasClass("active");

      $(".mi-accordion__item__header").not(this).each(function () {
        $(this).removeClass("active");
        $(this).next(".mi-accordion__item__content").slideUp(300);
        $(this).find("svg").css({ transform: "rotate(270deg)", transition: "transform 0.3s ease" });
      });

      if (isActive) {
        $(this).removeClass("active");
        $content.slideUp(300);
        $icon.css({ transform: "rotate(270deg)", transition: "transform 0.3s ease" });
      } else {
        $(this).addClass("active");
        $content.slideDown(300);
        $icon.css({ transform: "rotate(360deg)", transition: "transform 0.3s ease" });
      }
    });
  };

  const handlerSnackbar = () => {
    const url = new URL(window.location.href);

    if (url.searchParams.get('submit_success') === '1') {

      miShowSnackbar('Setup-Prüfung erfolgreich übermittelt.', 'success');

      url.searchParams.delete('submit_success');

      window.history.replaceState({}, document.title, url.toString());
    }
  }

  function truncateLabel(text, limit = 20) {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  }

  const handlerLabelInlineEdit = () => {
    $(document).on("click", ".btn-edit-label", function (e) {
      e.stopPropagation();
      const $cell = $(this).closest(".label-inline-edit");
      const $labelValue = $cell.find(".label-value");
      const fullText = $labelValue.attr("data-full") ?? $labelValue.text();

      $cell.find(".label-input").val(fullText);
      $labelValue.hide();
      $cell.find(".btn-edit-label").hide();
      $cell.find(".label-input").show().focus();
    });

    $(document).on("click", ".label-input", function (e) {
      e.stopPropagation();
    });

    $(document).on("keydown", ".label-input", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        $(this).trigger("blur");
      }
    });

    $(document).on("blur", ".label-input", function () {
      const $input = $(this);
      const $cell = $input.closest(".label-cell");
      const $wrapper = $input.closest(".label-inline-edit");
      const isDemo = $cell.data("demo") === true || $cell.data("demo") === "true";
      const postId = $cell.data("post-id");
      const newValue = $input.val();
      const oldValue = $wrapper.find(".label-value").attr("data-full") ?? $wrapper.find(".label-value").text();

      if (newValue === oldValue) {
        $wrapper.find(".label-input").hide();
        $wrapper.find(".btn-edit-label").show();
        $wrapper.find(".label-value").show();
        return;
      }

      // Demo row -> for dashboard general user role
      if (isDemo) {
        $wrapper.find(".label-input").hide();
        $wrapper.find(".btn-edit-label").hide();
        $wrapper.find(".label-value").text("Speichern...").show().addClass("is-loading");

        setTimeout(() => {
          $wrapper.find(".label-value")
            .removeClass("is-loading")
            .text(truncateLabel(newValue))
            .attr("data-full", newValue)
            .show();
          $wrapper.find(".btn-edit-label").show();

          const translations = window.themeObj?.translationText || {};
          miShowSnackbar(translations.labelUpdateSuccess || "Label updated successfully.", "success");
        }, 500);

        return;
      }

      $wrapper.find(".label-input").hide();
      $wrapper.find(".btn-edit-label").hide();
      $wrapper.find(".label-value").text("Speichern...").show().addClass("is-loading");

      $.ajax({
        url: themeObj.ajaxUrl,
        type: "POST",
        data: {
          action: themeObj.ajax.pcf_update_label.action,
          nonce: themeObj.ajax.pcf_update_label.nonce,
          post_id: postId,
          label: newValue,
        },
        success: (res) => {
          $wrapper.find(".label-value").removeClass("is-loading");
          $wrapper.find(".btn-edit-label").show();

          const translations = window.themeObj?.translationText || {};

          if (res.success) {
            $wrapper.find(".label-value")
              .text(truncateLabel(res.data.label))
              .attr("data-full", res.data.label)
              .show();
            miShowSnackbar(translations.labelUpdateSuccess || "Label updated successfully.", "success");
          } else {
            $wrapper.find(".label-value")
              .text(truncateLabel(oldValue))
              .attr("data-full", oldValue)
              .show();
            miShowSnackbar(res.data.message || translations.labelUpdateError || "Failed to update label.", "error");
          }
        },
        error: () => {
          const translations = window.themeObj?.translationText || {};
          $wrapper.find(".label-value")
            .removeClass("is-loading")
            .text(truncateLabel(oldValue))
            .attr("data-full", oldValue)
            .show();
          $wrapper.find(".btn-edit-label").show();
          miShowSnackbar(translations.labelServerError || "A server error occurred.", "error");
        },
      });
    });
  };

  init();
};

try {
  dashboard();
} catch (error) {
  console.error("dashboard", error);
}
